import phones from '../../../../Imgs/newIcons/nena.png'
import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import { Link } from 'react-router-dom'
import whatsapp from '../../../../Imgs/svg/brand-whatsapp.svg'
import checkIcon from '../../../../Imgs/Home/check.svg'

function SoonMobile() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.3 })

  return (
    <>
      <div className="flex flex-col bg-[#F8F8F8]">
        <div className="mx-auto px-4 lg:px-12 pt-10 w-full max-w-7xl">
          <div
            ref={ref}
            className="flex flex-col lg:flex-row items-end justify-between gap-8"
          >
            <div className="relative flex-1">
              <div className="p-2">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.6 }}
                  className="flex flex-col items-left text-left space-y-12"
                >
                  <h1 className="text-3xl lg:text-4xl xl:text-5xl font-bold -mt-7">
                    Nuestra plataforma{' '}
                    <span className="text-Main">Pide y Pasa</span>, reinventada
                    para los negocios
                  </h1>
                  <ul className="mt-5 space-y-3 mx-[10px] list-none pl-0 !flex-col !justify-start">
                    <motion.li
                      initial={{ opacity: 0, x: -30 }}
                      animate={isInView ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.5, delay: 0.1 }}
                      className="flex items-start gap-3"
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        className="w-6 h-6 flex-shrink-0 mt-1"
                      />
                      <span className="text-sm md:text-xl">
                        Restaurantes independientes.
                      </span>
                    </motion.li>
                    <motion.li
                      initial={{ opacity: 0, x: -30 }}
                      animate={isInView ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.5, delay: 0.2 }}
                      className="flex items-start gap-3"
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        className="w-6 h-6 flex-shrink-0 mt-1"
                      />
                      <span className="text-sm md:text-xl">
                        Cadenas de restaurantes.
                      </span>
                    </motion.li>
                    <motion.li
                      initial={{ opacity: 0, x: -30 }}
                      animate={isInView ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.5, delay: 0.3 }}
                      className="flex items-start gap-3"
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        className="w-6 h-6 flex-shrink-0 mt-1"
                      />
                      <span className="text-sm md:text-xl">Cafeterías</span>
                    </motion.li>
                    <motion.li
                      initial={{ opacity: 0, x: -30 }}
                      animate={isInView ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.5, delay: 0.4 }}
                      className="flex items-start gap-3"
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        className="w-6 h-6 flex-shrink-0 mt-1"
                      />
                      <span className="text-sm md:text-xl">
                        Negocios de comida rápida.
                      </span>
                    </motion.li>
                    <motion.li
                      initial={{ opacity: 0, x: -30 }}
                      animate={isInView ? { opacity: 1, x: 0 } : {}}
                      transition={{ duration: 0.5, delay: 0.5 }}
                      className="flex items-start gap-3"
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        className="w-6 h-6 flex-shrink-0 mt-1"
                      />
                      <span className="text-sm md:text-xl">
                        Establecimientos gastronómicos
                      </span>
                    </motion.li>
                  </ul>
                  <motion.button
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 1 }}
                    className="bg-[#47C257] mx-auto mt-[20px] px-[20px] py-[10px] mb-12 flex items-center text-white font-semibold rounded-full"
                  >
                    <img
                      src={whatsapp}
                      alt="whatsapp"
                      className="h-[35px] mr-[15px] filter invert"
                    />
                    <Link
                      to={'https://api.whatsapp.com/send?phone=573023050307'}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Hablar con un asesor
                    </Link>
                  </motion.button>
                </motion.div>
              </div>

              <div className="block lg:hidden">
                <img
                  src={phones}
                  alt="phones"
                  className="z-50 mx-auto max-w-full h-auto"
                />
              </div>
            </div>
            <motion.img
              initial={{ opacity: 0, x: 50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.3 }}
              src={phones}
              alt="phones"
              className="z-50 hidden lg:block flex-1 max-w-md xl:max-w-2xl h-auto object-contain object-bottom"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default SoonMobile
